import { createHead } from '@unhead/vue'
import { createPinia } from 'pinia'
import { createApp } from 'vue'
import 'virtual:uno.css'

import '@shared/util/polyfill'
import { logError } from '@shared/util/bi/log'
import { setDomain } from '@shared/util/cookie'
import selectDefault from '@qs-plus/directive/selectDefault'
import App from '../App.vue'
import { installPlugins } from '@/plugins'
import { registerRouter } from '@/router/util'
import router, { route } from '@/router/index'

setDomain(`.${import.meta.env.VITE_SITE_URL.replace(/https?:\/\//, '').split('.').slice(-2).join('.')}`)
registerRouter(route, router)
const app = createApp(App)
app.use(createPinia())
app.use(createHead())
installPlugins(app)
app.use(router)
app.use(selectDefault)
app.mount('#app')

app.config.errorHandler = err => logError(err)
